/**
 * Apple's momentum projection (WWDC 2018, "Designing Fluid Interfaces"): how
 * far a released gesture would carry if it decayed like a scroll, so a flick
 * lands where it was thrown rather than where the finger let go.
 */

/** Velocity kept per millisecond: 0.998 is scroll's feel, 0.99 snappier. */
const DECELERATION_RATE = 0.998;

/** The distance a release at `velocity` (units per second) travels on. */
const projectMomentum = (
  velocity: number,
  decelerationRate: number = DECELERATION_RATE,
) => ((velocity / 1000) * decelerationRate) / (1 - decelerationRate);

/** A drag this far, in px, pages a carousel; shorter ones settle back. */
const SWIPE_DISTANCE = 60;
// A pager's deceleration: snappier than a scroll's, so a slow drag released
// short of the threshold still settles back.
const PAGER_DECELERATION = 0.99;

/**
 * Which way a released horizontal drag pages, judged where it would carry
 * rather than where it let go, so a quick flick pages even when it travelled
 * only a little: 1 to the next, -1 to the previous, 0 to stay.
 */
export const swipeStep = (offsetX: number, velocityX: number): -1 | 0 | 1 => {
  const projected = offsetX + projectMomentum(velocityX, PAGER_DECELERATION);
  if (projected <= -SWIPE_DISTANCE) return 1;
  if (projected >= SWIPE_DISTANCE) return -1;
  return 0;
};

/** What's left of a velocity after `elapsedMs` of that same decay. */
export const decayVelocity = (
  velocity: number,
  elapsedMs: number,
  decelerationRate: number = DECELERATION_RATE,
) => velocity * decelerationRate ** elapsedMs;
